/* Blackheath custom product gallery: thumbnail swap + full-screen lightbox. */
(function () {
  var lb;

  function openLightbox(src) {
    if (!lb) {
      lb = document.createElement('div');
      lb.className = 'bhs-lightbox';
      lb.innerHTML = '<img alt="">';
      lb.addEventListener('click', function () { lb.classList.remove('is-open'); });
      document.body.appendChild(lb);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && lb) lb.classList.remove('is-open');
      });
    }
    lb.querySelector('img').src = src;
    lb.classList.add('is-open');
  }

  function init(gallery) {
    var main = gallery.querySelector('.bhs-gallery__main');
    if (!main) return;
    var thumbs = gallery.querySelectorAll('.bhs-gallery__thumb');
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        var ss = btn.getAttribute('data-srcset');
        if (full) main.src = full;
        if (ss) main.srcset = ss;
        thumbs.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
    main.addEventListener('click', function () { openLightbox(main.src); });
  }

  function boot() {
    document.querySelectorAll('[data-bhs-gallery]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
